import { createAction } from "@reduxjs/toolkit";

export interface WebSocketPayload {
    widgetId: string; 
}

export const webSocketActions = createAction<WebSocketPayload>("webSocketActions");
